import { __rest } from "tslib";
import React from 'react';
import SizePickerActionButton from '../../index';
const AddToCartButton = (_a) => {
    var { labelMoveToCart, labelMoveToCartAriaLabel, moveToCart, setShowOverlay, selectedVariantCode, className, isIconVisible = true } = _a, props = __rest(_a, ["labelMoveToCart", "labelMoveToCartAriaLabel", "moveToCart", "setShowOverlay", "selectedVariantCode", "className", "isIconVisible"]);
    if (!labelMoveToCart) {
        return null;
    }
    const handleOnClick = () => selectedVariantCode ? moveToCart(selectedVariantCode) : setShowOverlay(true);
    return (React.createElement(SizePickerActionButton, Object.assign({ onClick: handleOnClick, title: labelMoveToCartAriaLabel, className: className, isIconVisible: isIconVisible }, props), labelMoveToCart));
};
export default AddToCartButton;
//# sourceMappingURL=AddToCartButton.js.map